// 统计粒度
export const periodList = [
  { label: '统计粒度1分钟', value: 60},
  { label: '统计粒度5分钟', value: 300},
];


export const operatorList = [
  // { label: '智能检测', value: 'intelligent'},
  { label: '>', value: 'gt'},
  { label: '>=', value: 'ge'},
  { label: '<=', value: 'le'},
  { label: '<', value: 'lt'},
  { label: '=', value: 'eq'},
  { label: '!=', value: 'ne'},
  // { label: '天同比增长', value: 'day_increase'},
  // { label: '天同比下降', value: 'day_decrease'},
  // { label: '天同比波动', value: 'day_wave'},
  // { label: '周同比增长', value: 'week_increase'},
  // { label: '周同比下降', value: 'week_decrease'},
  // { label: '周同比波动', value: 'week_wave'},
  { label: '环比增长', value: 'cycle_increase'},
  { label: '环比下降', value: 'cycle_decrease'},
  { label: '环比波动', value: 'cycle_wave'},
  { label: '无数据上报', value: 'no_data'},
];

// gt/ge/lt/le/eq/ne/cycle_increase/cycle_decrease/cycle_wave/no_data


export const continuePeriodList = [
  { label: '持续1个数据点', value: 1},
  { label: '持续2个数据点', value: 2},
  { label: '持续3个数据点', value: 3},
  { label: '持续4个数据点', value: 4},
  { label: '持续5个数据点', value: 5},
];


export const noticeFrequencyList = [
  { label: '只告警一次', value: 0},
  { label: '每五分钟告警一次', value: 300},
  { label: '每十分钟告警一次', value: 600},
  { label: '每十五分钟告警一次', value: 900},
  { label: '每三十分钟告警一次', value: 1800},
  { label: '每一小时告警一次', value: 3600},
  { label: '每两小时告警一次', value: 7200},
  { label: '每三小时告警一次', value: 10800},
  { label: '每六小时告警一次', value: 21600},
  { label: '每十二小时告警一次', value: 43200},
  { label: '每一天告警一次', value: 86400},
  // { label: '周期指数递增', value: 86400},
];

export const defalutConditionList = [
  {
    metricName: 'CpuUsage',
    period: 60,
    operator: 'gt',
    value: 95,
    continuePeriod: 1,
    noticeFrequency: 300,
    metricText: 'CPU 利用率过高会容易引起服务响应速度变慢、服务器登录不上等问题。可能由硬件、系统进程、业务进程或者木马病毒等因素所致。详见',
    metricTextLink: 'https://cloud.tencent.com/document/product/248/44698',
    operatorLink: 'https://cloud.tencent.com/document/product/248/68508',
  },
  {
    metricName: 'Outratio',
    period: 60,
    operator: 'gt',
    value: 95,
    continuePeriod: 1,
    noticeFrequency: 300,
    metricText: '计算方式：外网出带宽和外网入带宽中的最大值 / 购买或设置的带宽上限。',
    operatorLink: 'https://cloud.tencent.com/document/product/248/68508',
  },
  {
    metricName: 'MemUsage',
    period: 60,
    operator: 'gt',
    value: 95,
    continuePeriod: 1,
    noticeFrequency: 300,
    metricText: '',
    operatorLink: 'https://cloud.tencent.com/document/product/248/68508',
  },
  {
    metricName: 'CvmDiskUsage',
    period: 60,
    operator: 'gt',
    value: 95,
    continuePeriod: 1,
    noticeFrequency: 300,
    metricText: '不论是系统盘还是数据盘，任意一个磁盘的任意一个分区达到阈值都会产生告警。',
    operatorLink: 'https://cloud.tencent.com/document/product/248/68508',
  },
];
